import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { AppLoaderComponent } from 'app/shared/components/app-loader/app-loader.component';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {
  private dialogRef: MatDialogRef<AppLoaderComponent>;
  private openCount = 0;

  constructor(private dialog: MatDialog) { }

  public open(title: string = ''): Observable<boolean> {
    this.openCount++;
    if (this.openCount === 1) {
      this.dialogRef = this.dialog.open(AppLoaderComponent, { 
        disableClose: true, 
        backdropClass: 'light-backdrop' 
      });
      this.dialogRef.updateSize('200px');
      this.dialogRef.componentInstance.title = title;
      
      const currentRef = this.dialogRef;
      this.dialogRef.afterClosed().subscribe(() => {
        if (this.dialogRef === currentRef) {
          this.openCount = 0;
          this.dialogRef = null;
        }
      });
    }
    return this.dialogRef ? this.dialogRef.afterClosed() : of(true);
  }

  public close() {
    if (this.openCount > 0) {
      this.openCount--;
      if (this.openCount === 0 && this.dialogRef) {
        this.dialogRef.close();
        this.dialogRef = null;
      }
    }
  }
}
